var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"8b04278b3cb61533218a985e844f4753307c749a"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["breitbart-nextjs-web@sentry"]={id:"8b04278b3cb61533218a985e844f4753307c749a"};
      